import { eventsConfig } from 'constants/eventOptions';

export interface IEntity {
  name: string;
  types: string[];
}

export interface ISuccesRatioStatistics {
  failure_count: number;
  success_count: number;
  total: number;
}

export interface ITransformedSuccesRatioStatistics {
  failureCount: number;
  successCount: number;
  total: number;
}

export interface IHook {
  events: IEntity[];
}

export const transformHookResponse = (hook: any): { events: string[] } => ({
  ...hook,
  enableSourceEvents: !!hook.enableSourceEvents,
  events: hook.events?.map((event: any) => ({
    ...event,
    types: eventsConfig[event.name]?.map((i) => (event.types.includes(i) ? i : undefined)),
  })),
});

export const transformRolesResponse = (roles: IEntity[]): IEntity[] =>
  roles?.map((role) => ({ ...role, types: role.types.filter((type) => Boolean(type)) }));

export const transformHookSuccessStatisticsResponse = (
  successRatioSatistics: ISuccesRatioStatistics
): ITransformedSuccesRatioStatistics => ({
  total: successRatioSatistics.total,
  successCount: successRatioSatistics.success_count,
  failureCount: successRatioSatistics.failure_count,
});
